import { ref } from "vue";
import { Control, DomEvent, DomUtil } from "leaflet";

import { courierData } from "@client/elements/repository";
import { unique } from "@/services/unique";

export const showSidebar = ref<boolean>(true);

export const Sidebar = Control.extend({
	options: {
		position: "topleft"
	},
	onAdd: function () {
		const container = DomUtil.create("div", "leaflet-bar leaflet-control");
		const button = DomUtil.create("a", "leaflet-control-button", container);
		button.innerText = "☰";

		DomEvent.disableClickPropagation(button);
		DomEvent.on(button, "click", () => (showSidebar.value = !showSidebar.value));

		return container;
	}
});

export const Filters = Control.extend({
	options: {
		position: "topleft"
	},
	onAdd: function () {
		const container = DomUtil.create("div", "leaflet-bar leaflet-courier-filters");
		if (!courierData.value) return container;

		unique(courierData.value, (courier) => courier.courier.name).forEach((courier) => {
			const button = DomUtil.create("a", "leaflet-control-button", container);
			button.innerHTML = `<img src="${courier.courier.images.mark}" alt="${courier.courier.name}" class="leaflet-control-button__icon" title="filter op ${courier.courier.service_class}" />`;

			DomEvent.disableClickPropagation(button);

			DomEvent.on(button, "click", function () {
				//
			});
		});

		return container;
	}
});
